import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { MUTATION_TYPE, useToast } from "hooks";
import { ModalForm, MODAL_SIZE } from "components/Modal";
import { css } from "@emotion/react";
import { GET_MISSIONS } from "graphql/queries";
import { REORGANIZE_MISSION_ROLE } from "graphql/mutations";
import { SIZE, TYPE } from "components/Form";

/**
 * ReorganizeRoleForm
 *
 * @param {function}    onClose   Callback function to close the modal
 * @param {object}      role      The role object to be reorganized
 */
const ReorganizeRoleForm = ({ onClose, role, ...props }) => {
  const { toast } = useToast();

  const initialValues = {
    missionId: role?.mission?.id,
  };

  const handleComplete = () => {
    toast.success(<FormattedMessage id="Missions.Roles.RoleAdvancedOptions.Reorganize.Success" />);
    onClose();
  };

  const handleError = () => toast.error(<FormattedMessage id="Missions.Roles.RoleAdvancedOptions.Reorganize.Error" />);

  return (
    <ModalForm
      title={<FormattedMessage id="Missions.Roles.RoleAdvancedOptions.Reorganize.Title" />}
      description={<FormattedMessage id="Missions.Roles.RoleAdvancedOptions.Reorganize.Description" />}
      data={FORM_DATA(role?.mission)}
      initialValues={initialValues}
      updateId={role?.id}
      mutationType={MUTATION_TYPE.update}
      mutationData={{
        mutationName: {
          update: REORGANIZE_MISSION_ROLE,
        },
      }}
      size={MODAL_SIZE.small}
      onClose={onClose}
      onCompleted={handleComplete}
      onError={handleError}
      primaryButtonMessageId="Missions.Roles.RoleAdvancedOptions.Reorganize.Cta"
      {...props}
    />
  );
};

const FORM_DATA = (mission) => [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        label: <FormattedMessage id="Missions.Roles.RoleAdvancedOptions.Reorganize.Mission" />,
        type: TYPE.select,
        size: SIZE.xlarge,
        properties: {
          name: "missionId",
          queryName: GET_MISSIONS,
          queryKeyName: "missions",
          queryFieldName: "missions",
          queryVariables: { includeRoles: false, filters: { organizationId: mission?.organization?.id } },
          labelKey: "nameWithOrganization",
          valueKey: "id",
          isSearchable: true,
          isClearable: false,
          noOptionsMessage: "No missions found",
          querySearchFieldName: "name",
          placeholder: "Search by name...",
          // As the intended mission could be down in the paginated results
          selection: mission
            ? { id: mission.id, nameWithOrganization: mission.nameWithOrganization || mission.name }
            : undefined,
          required: true,
        },
      },
    ],
  },
];

ReorganizeRoleForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  role: PropTypes.object,
};

export default ReorganizeRoleForm;
